import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    class: "sc-filter-my"
};
const _hoisted_2 = {
    key: 0,
    class: "sc-filter-my-loading"
};
const _hoisted_3 = {
    key: 1,
    class: "sc-filter-my-list"
};
const _hoisted_4 = [
    "onClick"
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_skeleton = _resolveComponent("el-skeleton");
    const _component_el_empty = _resolveComponent("el-empty");
    const _component_el_icon_delete = _resolveComponent("el-icon-delete");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_el_popconfirm = _resolveComponent("el-popconfirm");
    return _openBlock(), _createElementBlock("div", _hoisted_1, [
        $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_skeleton, {
                rows: 2,
                animated: ""
            })
        ])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
        }, [
            $data.myFilter.length <= 0 ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                "image-size": 100
            }, {
                description: _withCtx(()=>[
                        ..._cache[0] || (_cache[0] = [
                            _createElementVNode("h2", null, "没有常用的过滤", -1),
                            _createElementVNode("p", {
                                style: {
                                    "margin-top": "10px",
                                    "max-width": "300px"
                                }
                            }, "常用过滤可以将多个过滤条件保存为一个集合，方便下次进行相同条件的过滤", -1)
                        ])
                    ]),
                _: 1
            })) : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("h2", null, "我的常用过滤", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.myFilter, (item, index)=>{
                    return _openBlock(), _createElementBlock("li", {
                        key: index,
                        onClick: ($event)=>$options.selectMyfilter(item)
                    }, [
                        _createElementVNode("label", null, _toDisplayString(item.title), 1),
                        _createVNode(_component_el_popconfirm, {
                            title: "确认删除此常用过滤吗？",
                            onConfirm: ($event)=>$options.closeMyfilter(item, index)
                        }, {
                            reference: _withCtx(()=>[
                                    _createVNode(_component_el_icon, {
                                        class: "del",
                                        onClick: _withModifiers(()=>{}, [
                                            "stop"
                                        ])
                                    }, {
                                        default: _withCtx(()=>[
                                                _createVNode(_component_el_icon_delete)
                                            ]),
                                        _: 1
                                    })
                                ]),
                            _: 1
                        }, 8, [
                            "onConfirm"
                        ])
                    ], 8, _hoisted_4);
                }), 128))
            ]))
        ], 64))
    ]);
}
